<template>
  <!--
    Native-style bottom tab bar, rendered only on phones (see App.vue
    `v-if="isPhone"`). Shows the first few permission-allowed primary
    destinations plus a "More" tab that opens the full navigation drawer.
    `app` reserves layout space so page content isn't hidden behind it.
  -->
  <v-bottom-navigation
    app
    grow
    color="primary"
    class="mobile-bottom-nav"
    :value="activeTab"
  >
    <v-btn
      v-for="tab in tabs"
      :key="tab.route"
      :value="tab.route"
      :to="tab.route"
      exact
    >
      <span class="tab-label">{{ tab.short }}</span>
      <v-icon>{{ tab.icon }}</v-icon>
    </v-btn>

    <v-btn value="__more" @click="openDrawer">
      <span class="tab-label">More</span>
      <v-icon>mdi-dots-horizontal</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapGetters } from "vuex";
import {
  navLinks,
  primaryMobileTabs,
  visibleNavLinks,
} from "@/config/navLinks.js";

export default {
  name: "MobileBottomNav",
  computed: {
    ...mapGetters({
      user: "auth/user",
      hasPermission: "permission/hasPermission",
    }),
    // Primary tabs the user can actually reach, in the preferred order,
    // capped at 4 so the bar stays uncrowded (+ the More tab = 5).
    tabs() {
      const allowed = visibleNavLinks(this.user, this.hasPermission);
      const byRoute = Object.fromEntries(allowed.map((l) => [l.route, l]));
      return primaryMobileTabs
        .filter((t) => byRoute[t.route])
        .slice(0, 4)
        .map((t) => ({
          route: t.route,
          short: t.short,
          icon: byRoute[t.route].icon || navLinks.find((l) => l.route === t.route)?.icon,
        }));
    },
    // Highlight the active tab (falls back to no highlight when on a page
    // that lives only in the drawer).
    activeTab() {
      return this.$route.path;
    },
  },
  methods: {
    openDrawer() {
      this.$store.dispatch("navbar/setDrawer", true);
    },
  },
};
</script>

<style scoped>
.mobile-bottom-nav {
  padding-bottom: env(safe-area-inset-bottom);
}
.tab-label {
  font-size: 0.62rem;
  letter-spacing: 0.02em;
  margin-bottom: 2px;
}
/* Keep the active-tab tint subtle and the icons comfortable to tap. */
.mobile-bottom-nav >>> .v-btn {
  min-width: 0;
}
</style>
